import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  AnimalShelterLocation,
  LegacyInfoLocation,
  LegacyShelterLocation,
  FoodLocation,
  ShelterLocation,
  SmallAnimalShelterLocation,
  LargeAnimalShelterLocation,
  InfoLocation,
  GeneralLocation,
  MealsLocation,
  FirstAidLocation,
  TEPLocation,
  SandBagsLocation,
  WaterLocation,
  FarmersMarketLocation,
  FoodPantryLocation,
  MaskDistributionLocation,
  CommunityDistributionLocation,
} from 'features/mapping/icons';
import { useLocationV2Enabled } from 'features/locations/hooks/useLocationV2Enabled';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const LocationsLegend = (): JSX.Element => {
  const { t } = useTranslation();
  const showLocationV2 = useLocationV2Enabled();

  if (showLocationV2) {
    return (
      <List
        disablePadding
        dense
        subheader={
          <LegendSectionTitle>
            {t('map.legends.locations.title')}
          </LegendSectionTitle>
        }
      >
        <LegendListItem
          iconSrc={CommunityDistributionLocation.data}
          primaryText={t(
            'map.legends.locations.legends.communityDistribution.title',
          )}
          secondary={t(
            'map.legends.locations.legends.communityDistribution.subtitle',
          )}
        />
        <LegendListItem
          iconSrc={ShelterLocation.data}
          primaryText={t('map.legends.locations.legends.evacShelter.title')}
          secondary={t('map.legends.locations.legends.evacShelter.subtitle')}
        />
        <LegendListItem
          iconSrc={FarmersMarketLocation.data}
          primaryText={t('map.legends.locations.legends.farmersMarket.title')}
          secondary={t('map.legends.locations.legends.farmersMarket.subtitle')}
        />
        <LegendListItem
          iconSrc={FirstAidLocation.data}
          primaryText={t('map.legends.locations.legends.firstAid.title')}
          secondary={t('map.legends.locations.legends.firstAid.subtitle')}
        />
        <LegendListItem
          iconSrc={FoodPantryLocation.data}
          primaryText={t('map.legends.locations.legends.foodPantry.title')}
          secondary={t('map.legends.locations.legends.foodPantry.subtitle')}
        />
        <LegendListItem
          iconSrc={GeneralLocation.data}
          primaryText={t('map.legends.locations.legends.general.title')}
          secondary={t('map.legends.locations.legends.general.subtitle')}
        />
        <LegendListItem
          iconSrc={InfoLocation.data}
          primaryText={t('map.legends.locations.legends.information.title')}
          secondary={t('map.legends.locations.legends.information.subtitle')}
        />
        <LegendListItem
          iconSrc={LargeAnimalShelterLocation.data}
          primaryText={t(
            'map.legends.locations.legends.largeAnimalShelter.title',
          )}
          secondary={t(
            'map.legends.locations.legends.largeAnimalShelter.subtitle',
          )}
        />
        <LegendListItem
          iconSrc={MaskDistributionLocation.data}
          primaryText={t(
            'map.legends.locations.legends.maskDistribution.title',
          )}
          secondary={t(
            'map.legends.locations.legends.maskDistribution.subtitle',
          )}
        />
        <LegendListItem
          iconSrc={MealsLocation.data}
          primaryText={t('map.legends.locations.legends.meals.title')}
          secondary={t('map.legends.locations.legends.meals.subtitle')}
        />
        <LegendListItem
          iconSrc={SandBagsLocation.data}
          primaryText={t('map.legends.locations.legends.sandBags.title')}
          secondary={t('map.legends.locations.legends.sandBags.subtitle')}
        />
        <LegendListItem
          iconSrc={SmallAnimalShelterLocation.data}
          primaryText={t(
            'map.legends.locations.legends.smallAnimalShelter.title',
          )}
          secondary={t(
            'map.legends.locations.legends.smallAnimalShelter.subtitle',
          )}
        />
        <LegendListItem
          iconSrc={TEPLocation.data}
          primaryText={t(
            'map.legends.locations.legends.temporaryEvacPoint.title',
          )}
          secondary={t(
            'map.legends.locations.legends.temporaryEvacPoint.subtitle',
          )}
        />
        <LegendListItem
          iconSrc={WaterLocation.data}
          primaryText={t('map.legends.locations.legends.water.title')}
          secondary={t('map.legends.locations.legends.water.subtitle')}
        />
      </List>
    );
  }

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>
          {t('map.legends.locations.title')}
        </LegendSectionTitle>
      }
    >
      <LegendListItem
        iconSrc={LegacyShelterLocation.data}
        primaryText={t(
          'map.legends.locations.legends.legacy.evacShelter.title',
        )}
        secondary={t(
          'map.legends.locations.legends.legacy.evacShelter.subtitle',
        )}
      />
      <LegendListItem
        iconSrc={AnimalShelterLocation.data}
        primaryText={t(
          'map.legends.locations.legends.legacy.animalShelter.title',
        )}
        secondary={t(
          'map.legends.locations.legends.legacy.animalShelter.subtitle',
        )}
      />
      <LegendListItem
        iconSrc={LegacyInfoLocation.data}
        primaryText={t(
          'map.legends.locations.legends.legacy.information.title',
        )}
        secondary={t(
          'map.legends.locations.legends.legacy.information.subtitle',
        )}
      />
      <LegendListItem
        iconSrc={FoodLocation.data}
        primaryText={t('map.legends.locations.legends.legacy.food.title')}
        secondary={t('map.legends.locations.legends.legacy.food.subtitle')}
      />
    </List>
  );
};
